<div class="window" id="{{component}}" (click)="moveToTop()">
        <div class="title-bar" (mousedown)="onMouseDown($event)" (touchstart)="onTouchStart($event)">
                <span class="title-text">{{ title }}</span>
                <div class="window-buttons">
                        <button class="btn-maximize">□</button>
                        <button class="btn-minimize">_</button>
                        <button class="btn-close" (click)="closeWindow()">X</button>
                </div>
        </div>
        <div class="window-content">
                <app-about *ngIf="component == 'about'"></app-about>
                <app-contact *ngIf="component == 'contact'"></app-contact>
                <app-projects *ngIf="component == 'projects'"></app-projects>
                <app-minesweeper *ngIf="component == 'minesweeper'"></app-minesweeper>
                <app-postmodern-slime *ngIf="component == 'postmodernSlime'"></app-postmodern-slime>
                <app-permanent-address *ngIf="component == 'permanentAddress'"></app-permanent-address>
                <app-napkin-drawings *ngIf="component == 'napkinDrawings'"></app-napkin-drawings>
                <app-metaphysical *ngIf="component == 'metaphysical'"></app-metaphysical>
                <app-how-to *ngIf="component == 'howTo'"></app-how-to>
                <app-being-hater *ngIf="component == 'beingHater'"></app-being-hater>
                <app-bananas *ngIf="component =='bananas'"></app-bananas>
                <app-the-pitch *ngIf="component == 'thePitch'"></app-the-pitch>
                <app-walk-talk *ngIf="component == 'walkTalk'"></app-walk-talk>
                <app-five-minute-crafts *ngIf="component == 'fiveMinuteCrafts'"></app-five-minute-crafts>
                <app-talk-show *ngIf="component == 'talkShow'"></app-talk-show>
                <!-- <app-contact *ngIf="component != 'about' && component != 'contact' && component != 'projects' && component != 'minesweeper'"></app-contact> -->
        </div>
</div>